import HowItWorksRefer from "@/public/icons/howItWorkRefer.svg";

interface HowItWorksProps {
  email?: string;
}

const HowItWorks = ({ email }: HowItWorksProps) => {
  return (
    <div className="w-full mt-[16px]">
      <p className="font-bold text-base">How It Works</p>
      <div className="mt-[18px] flex flex-col lg:flex-row gap-[35px] relative lg:justify-between ">
        <div className="absolute h-full border border-r-0 ml-[29px] lg:hidden" />
        <div className="absolute w-[90%] border border-t-0 hidden lg:block mt-[30px] ml-[30px]" />
        <div className="flex gap-8 md:gap-16 lg:flex-col lg:gap-0 items-center z-10 lg:w-[66px] ">
          <div className="w-[60px] flex justify-center lg:h-[60px] items-center">
            {email ? (
              <div className="w-[28px] h-[28px] bg-landing-denim rounded-full flex items-center justify-center ">
                <p className="text-white text-center align-middle font-bold text-base">1</p>
              </div>
            ) : (
              <div className="p-1 border border-landing-denim rounded-full">
                <div className="w-[39px] h-[39px] bg-landing-denim rounded-full flex items-center justify-center ">
                  <p className="text-white text-center align-middle font-bold text-base">1</p>
                </div>
              </div>
            )}
          </div>

          <p className="font-normal  text-base text-black-80 lg:hidden">
            Share your unique referral link
          </p>
          <p className="font-normal  text-base text-black-80 hidden lg:block lg:text-center">
            Share your link
          </p>
        </div>
        <div className="flex gap-8 md:gap-16 lg:flex-col lg:gap-0 items-center z-10 lg:w-[66px] ">
          <div className="w-[60px] flex justify-center lg:h-[60px] items-center">
            {!email ? (
              <div className="w-[28px] h-[28px] bg-landing-cherry rounded-full flex items-center justify-center">
                <p className="text-white text-center align-middle font-bold text-base">2</p>
              </div>
            ) : (
              <div className="p-1 border border-landing-cherry rounded-full">
                <div className="w-[39px] h-[39px] bg-landing-cherry rounded-full flex items-center justify-center">
                  <p className="text-white text-center align-middle font-bold text-base">2</p>
                </div>
              </div>
            )}
          </div>
          <p className="font-normal text-base text-black-80 lg:text-center">Friend signs up</p>
        </div>
        <div className="flex gap-8 md:gap-16 lg:flex-col lg:gap-0 items-center z-10 lg:w-[66px] ">
          <div className="w-[60px] flex justify-center lg:h-[60px] items-center">
            <div className="w-[28px] h-[28px] bg-landing-orange rounded-full flex items-center justify-center">
              <p className=" text-center align-middle font-bold text-base">3</p>
            </div>
          </div>

          <p className="font-normal text-base text-black-80 lg:text-center">Friend moves in</p>
        </div>
        <div className="flex gap-8 md:gap-16 lg:flex-col lg:gap-0 items-center z-10 bg-grey-90 lg:w-[66px]">
          <HowItWorksRefer className="w-[60px] lg:h-[60px]" />
          <p className="font-normal text-base text-black-80 lg:text-center">You get £250</p>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
